import { render, staticRenderFns } from "./NotificationApiToOdoo.vue?vue&type=template&id=cc6e8e62&scoped=true&"
import script from "./NotificationApiToOdoo.vue?vue&type=script&lang=js&"
export * from "./NotificationApiToOdoo.vue?vue&type=script&lang=js&"
import style0 from "./NotificationApiToOdoo.vue?vue&type=style&index=0&id=cc6e8e62&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc6e8e62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc6e8e62')) {
      api.createRecord('cc6e8e62', component.options)
    } else {
      api.reload('cc6e8e62', component.options)
    }
    module.hot.accept("./NotificationApiToOdoo.vue?vue&type=template&id=cc6e8e62&scoped=true&", function () {
      api.rerender('cc6e8e62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/budget/NotificationApiToOdoo.vue"
export default component.exports